import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useRef } from 'react';
import Button from '@widget/buttons/Button';
import { UXPContext } from '@core/context/Context';
/**
 * The row after the last item: a marker that asks for the next page when it comes into view (in
 * the list's own scroll area or the page's, whichever scrolls), the "loading more" line, or
 * "Try again" when a page failed. While the marker stays in view after a page arrives (a short
 * page), the next one is asked for too.
 */
const InfiniteFooter = ({ paging, loading }) => {
    const context = useContext(UXPContext);
    const markerRef = useRef(null);
    const loadMore = useRef(paging.onLoadMore);
    loadMore.current = paging.onLoadMore;
    const active = paging.hasMore && !paging.appending && !paging.error && !loading;
    useEffect(() => {
        const el = markerRef.current;
        if (!el || !active || typeof IntersectionObserver === 'undefined')
            return;
        // Observing again after each page (active turns back on) reports the marker at once if it is still in view
        const observer = new IntersectionObserver(entries => {
            if (entries.some(e => e.isIntersecting))
                loadMore.current();
        }, { rootMargin: '200px 0px' });
        observer.observe(el);
        return () => observer.disconnect();
    }, [active, paging.resetKey, paging.count]);
    return _jsxs(_Fragment, { children: [_jsx("div", { ref: markerRef, className: "uxpcore_table__loadmore-marker", "aria-hidden": "true" }), paging.error
                ? _jsxs("div", { className: "uxpcore_table__loadmore uxpcore_table__loadmore--error", children: [_jsx("span", { children: context.$L('uxp-core.text.load-more-failed') }), _jsx(Button, { title: context.$L('uxp-core.text.try-again'), variant: "secondary", onClick: paging.onRetry })] })
                : paging.appending && _jsx("div", { className: "uxpcore_table__loadmore", children: context.$L('uxp-core.text.loading-more') })] });
};
export default InfiniteFooter;
